import { isProductionEnvironment } from 'features/app/constants';
import GoogleAnalytic from 'analytics/GoogleAnalytic';
import FacebookPixel from 'analytics/FacebookPixel';
import TwitterAnalytic from 'analytics/TwitterAnalytic';

const Analytics = () => {
  return isProductionEnvironment ? (
    <>
      <GoogleAnalytic />
      <FacebookPixel />
      <TwitterAnalytic />
    </>
  ) : null;
};

export default Analytics;
